globalThis.SaveForm = class SaveForm extends Dialogue {
  constructor() {
    super({
      title: "Save As",
      body: "Save name:",
      action() {
        if (!this.input.value) return true;
        if (globalThis.STORE.saves[this.input.value])
          new Dialogue({
            body: `Save "${this.input.value}" already exists. Do you want to overwrite it?`,
            action: () => this.save(),
          });
        else this.save();
      },
    });
    this.div.id = "save-form";
    this.input = document.createElement("input");
    this.input.placeholder = "...";
    this.input.addEventListener("keydown", cancelbubble, this.abort);
    this.body.append(this.input);
  }

  save() {
    if (!this.input.value) return;
    globalThis.STORE.saveWorldAs(this.input.value);
    if (globalThis.GAME.context === "local")
      globalThis.ROUTER.goto(`/local/${this.input.value}`);
  }
};
